import { generateId } from '@vedalib/editor/lib/utils/id'
import lodash from 'lodash'

import ControlItem from 'components/Editor/cource/layout/controls/ControlItem'
import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import Separator from 'components/Editor/cource/layout/controls/Separator'
import Button from 'components/uiKit/Button'
import { KitSize } from 'components/uiKit/KitTypes'
import { AppMode } from 'services/Store/Project/enums'
import { t } from 'services/Translation'

import type { SimulatorEditorActionsType } from './simulatorTypes'

const ACTIONS = (disabledPrev: boolean) => (disabledNext: boolean) =>
  ({
    PREV_ITEM: {
      icon: 'builderInputBack',
      value: 'PREV_ITEM',
      disabled: disabledPrev,
      label: t('common.prev'),
    },
    NEXT_ITEM: {
      icon: 'builderInputForward',
      value: 'NEXT_ITEM',
      disabled: disabledNext,
      label: t('common.next'),
    },
    ADD_FIELD: {
      value: 'ADD_FIELD',
      disabled: false,
      label: t('elements.simulator.form.addField'),
    },
  }) as const

const SimulatorEditorActions: SimulatorEditorActionsType = ({
  element: { value },
  setAppMode,
  customMode,
  mode,
  state,
  setState,
  onChange,
}) => {
  const isPro = mode.editorMode === AppMode.pro || customMode?.editorMode === AppMode.pro

  const activeItemIndex = Math.max(lodash.findIndex(value.items, { value: state?.active || '' }), 0)
  const activeItem = value.items[activeItemIndex]
  const disabledPrev = activeItemIndex === 0
  const disabledNext = activeItemIndex === value.items.length - 1 || value.items.length === 1

  const actionsWithPrev = ACTIONS(disabledPrev)
  const actions = actionsWithPrev(disabledNext)

  const nextItem = () => {
    setState({ active: value.items[activeItemIndex + 1].value })
  }
  const prevItem = () => {
    setState({ active: value.items[activeItemIndex - 1].value })
  }

  const addField = () => {
    const newField = {
      id: generateId(),
      x: 10,
      y: 10,
      width: '357px',
      height: '48px',
      value: '',
    }
    const updatedItems = value.items.map((item) => ({
      ...item,
      fields: item.value === activeItem?.value ? [...(item.fields || []), newField] : item.fields,
    }))
    onChange({ ...value, items: updatedItems })
  }

  return (
    <>
      {isPro && (
        <>
          <EditableProMode customMode={customMode} mode={mode} setAppMode={setAppMode} />
          <Separator />
        </>
      )}
      <ControlItem handler={prevItem} option={actions.PREV_ITEM} />
      <ControlItem handler={nextItem} option={actions.NEXT_ITEM} />
      <ControlItem handler={addField} option={actions.ADD_FIELD}>
        <Button name='addField' size={KitSize.S} styleType='secondary'>
          {actions.ADD_FIELD.label}
        </Button>
      </ControlItem>
    </>
  )
}

export default SimulatorEditorActions
